import { EL_COL_TYPE_ATTRIBUTE, EL_COL_TYPE_DIMENSION, EL_COL_TYPE_MEASURE, EL_COL_TYPE_TRANSLATION } from "../constants";

export const columnCanBeTranslated = (column)  => {
  return column.type === EL_COL_TYPE_ATTRIBUTE || column.type === EL_COL_TYPE_DIMENSION
}


export const clearTranslationsOfCurrentColumn = (columns, column) => {

  column.translations = null;
  const translationsOfCurrentColumn = columns.filter(c => 
    c.id !== column.id && c.type === EL_COL_TYPE_TRANSLATION && c.translationDefinition.transColId === column.id) || [];
    
    translationsOfCurrentColumn.forEach(c => {
      c.type = null;
      c.translationDefinition.transColId = null;
      c.translationDefinition.langCode = null;
      c.dimensionDefinition.role = null;
      c.dimensionDefinition.association = null;
    });
};

export const clearTranslatedColumn = (columns, column) => {
  let translatedColumn = null;

  columns.forEach(c => {
    if (c.id !== column.id && columnCanBeTranslated(c)) {
      const cTranslations = c.translations || [];
      cTranslations.forEach(translation => {
        if (translation.column === column.id) {
          translatedColumn = c;
        }
      })
    }
  });

  if (translatedColumn) {
    translatedColumn.translations = translatedColumn.translations.filter(translation =>
      translation.column !== column.id
    )
  }
}

export const assignTranslation = (columns, column) => {
  const translatedColumn = columns.find(c => c.id === column.translationDefinition.transColId)
  if (translatedColumn) {
    const translation = 
      { column:column.id, 
        lang:column.translationDefinition.langCode
      }
    let columnsTranslations = translatedColumn.translations || [];            
    columnsTranslations.push(translation);
    translatedColumn.translations = columnsTranslations;
  }
}

export const structureIsWellDefined = (t, structureColumns) => {
    let numberOfMeasures = 0;
    let numberOfDimensions = 0;
    let allColumunHasType = true;
    let translationsAreWellDefined = true;
    let translationHasDuplicateLanguage = false;
    for(let i = 0; i < (structureColumns || []).length; i++) {
        const column = structureColumns[i];
        if (column.type === null) {
            allColumunHasType = false;
        };
        if (column.type === EL_COL_TYPE_TRANSLATION) {
            if (column.translationDefinition.transColId === null || column.translationDefinition.langCode === null) {
                translationsAreWellDefined = false;
            } else {
              const sameLanguageColumn = structureColumns.find(c => 
                c.id !== column.id &&
                c.type === EL_COL_TYPE_TRANSLATION && 
                c.translationDefinition.transColId === column.translationDefinition.transColId && 
                c.translationDefinition.langCode === column.translationDefinition.langCode);
                if (sameLanguageColumn) {
                  translationHasDuplicateLanguage = true;
                }
            }
        } else if (column.type === EL_COL_TYPE_DIMENSION) {
            numberOfDimensions++;
        }
        else if (column.type === EL_COL_TYPE_MEASURE) {
            numberOfMeasures++;
        }
    }

    const messages = [];
    if (!allColumunHasType) {
        messages.push(t('components.easyLoading.error.structure.columnTypes'))
    };
    if (!translationsAreWellDefined) {
        messages.push(t('components.easyLoading.error.structure.notWellDefinedTranslations'))
    };
    if (translationHasDuplicateLanguage) {
      messages.push(t('components.easyLoading.error.structure.duplicateLanguageTranslations'))
  };
    if (numberOfMeasures !== 1) {
        messages.push(t('components.easyLoading.error.structure.measures'))
    };
    if (numberOfDimensions < 2) {
        messages.push(t('components.easyLoading.error.structure.dimensions'))
    }
    
    return {
        result: allColumunHasType && translationsAreWellDefined &&  !translationHasDuplicateLanguage &&
                numberOfMeasures === 1 && numberOfDimensions >= 2,
        messages: messages
     }
}


// WEBPACK FOOTER //
// ./src/components/easy-loading/structure-step/utils.js